/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attributes_Status_PendingInputs */

const en_attributes_status_pending = /** @type {(inputs: Attributes_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted, to review`)
};

/**
* | output |
* | --- |
* | "Submitted, to review" |
*
* @param {Attributes_Status_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attributes_status_pending = /** @type {((inputs?: Attributes_Status_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attributes_Status_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attributes_status_pending(inputs)
});